module.exports = __webpack_public_path__ + "static/media/img4.fd7ff5a9.jpg";